import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'black-teach-cta-section',
  templateUrl: './teach-cta-section.component.html',
  styleUrls: ['./teach-cta-section.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class TeachCtaSectionComponent {}
